import moment from 'moment';
import * as yup from 'yup';

import Base from './Base';
import IconDcm from '../assets/images/ic-dcm.svg';
import IconDoc from '../assets/images/ic-doc.svg';
import IconPicture from '../assets/images/ic-picture.svg';
import IconVideo from '../assets/images/ic-video.svg';

export const EDUCATIONAL = 'educational';
export const SUPPLEMENTARY = 'supplementary';
export const SHAREDSTUDY = 'sharedStudy';
export const SELFHELP = 'self-help';

export const TEXT = 'text';
export const PDF = 'pdf';
export const DOCX = 'docx';
export const DOCS = 'document';
export const DOCS_IMAGES = 'file';
export const DCM = 'dcm';
export const IMAGE = 'image';
export const THREE = '3d';
export const VIDEO = 'video';

export const resourceCategories = [
  { label: 'Educational', value: EDUCATIONAL },
  { label: 'Supplementary', value: SUPPLEMENTARY },
  { label: 'Ambra Studies', value: SHAREDSTUDY },
  { label: 'Self Help Materials', value: SELFHELP },
];

export const resourceTypes = [
  { label: 'Images', value: IMAGE },
  { label: '3D Models', value: THREE },
  { label: 'Videos', value: VIDEO },
  { label: 'Study', value: DCM },
  { label: 'Documents', value: DOCS },
];

export const reducedResourceTypes = [
  { label: 'Imaging study (MRI, xray, etc)', value: DCM },
  { label: 'Documents or photos', value: DOCS_IMAGES },
  { label: 'Videos', value: VIDEO },
];

export const iconSetup = {
  [DCM]: IconDcm,
  [DOCS]: IconDoc,
  [IMAGE]: IconPicture,
  [VIDEO]: IconVideo,
};

export const resourcePrivacy = {
  GLOBAL: 'global',
  PRIVATE: 'private',
  WORKSPACE: 'workspace',
};

export const resourcePrivacyList = [
  { label: 'Global Mediphany', value: resourcePrivacy.GLOBAL },
  { label: 'Workspace Only', value: resourcePrivacy.WORKSPACE },
  { label: 'Private', value: resourcePrivacy.PRIVATE },
];

export const templatePrivacyList = [{ label: 'Mediphany - Global ', value: resourcePrivacy.GLOBAL }];

export const resourcePrivacyFilterList = [
  { label: 'Global Mediphany', value: resourcePrivacy.GLOBAL },
  { label: 'Workspace Only', value: resourcePrivacy.WORKSPACE },
  { label: 'My Resources', value: resourcePrivacy.PRIVATE },
];

export const templatePrivacyFilterList = [
  { label: 'Global Collections', value: resourcePrivacy.GLOBAL },
  { label: 'Workspace Only', value: resourcePrivacy.WORKSPACE },
  { label: 'My Collections', value: resourcePrivacy.PRIVATE },
];

const resourceSchema = yup.object().shape({
  anatomy: yup.string().when('category', {
    is: SUPPLEMENTARY,
    otherwise: yup.string(),
    then: yup.string().required('Anatomy is required for supplementary resources'),
  }),
  description: yup.string(),
  modality: yup.string().when('category', {
    is: SUPPLEMENTARY,
    otherwise: yup.string(),
    then: yup.string().required('Modality is required for supplementary resources'),
  }),
  selfHelpCategoryName: yup.string().required('Self help category can not be empty'),
  title: yup.string().required('Title can not be empty'),
  type: yup.string().required('Type is required'),
});

export default class Resource extends Base {
  static validateCreate(item, fields) {
    return super.validate(item, fields, resourceSchema);
  }

  id;
  category;
  createdAt;
  description;
  title;
  isReady;

  tags;
  anatomy;
  modality;
  resource;
  viewerLink;
  selfHelpCategoryName;

  constructor(source) {
    super();
    this.clone(source);
    this.createdAt = this.createdAt ? new Date(this.createdAt) : null;
  }

  get type() {
    return this.resource?.type;
  }

  get thumbnailPath() {
    return this.resource?.thumbnailPath;
  }

  get path() {
    return this.resource?.path;
  }

  get h264Path() {
    return this.resource?.h264Path;
  }

  get patientNameGender() {
    const rcPatientName = this.resource?.patientName || '';
    const rcGender = this.resource?.patientSex || '';

    if (!rcPatientName) return '';
    if (!rcGender) return rcPatientName;
    return `${rcPatientName} (${rcGender})`;
  }

  get dateOfBirth() {
    const rcBirthDate = this.resource?.patientBirthDate || '';
    if (!rcBirthDate) return '';
    // Year, Month, Date
    const dateSetup = moment(rcBirthDate, 'YYYYMMDD');
    return dateSetup.format('MM-DD-YYYY');
  }

  get studyDateTime() {
    const rcStudyDate = this.resource?.studyDate || '';
    const rcStudyTime = this.resource?.studyTime || '';

    if (!rcStudyDate || !rcStudyTime) return '';

    const studyDate = moment(rcStudyDate, 'YYYYMMDD');
    const studyTime = moment(rcStudyTime.split('.')[0], 'hhmmss');

    return `${studyDate.format('MM-DD-YYYY')} | ${studyTime.format('hh:mm a')}`;
  }
}
